/**
 * Product Card Color Swatches
 *
 * Handles color swatch interactions on product cards in collection/product grids.
 * - Clicking a swatch updates the product image to show the variant's image
 * - Adds active state outline to the selected swatch
 * - Does NOT navigate to product page on swatch click
 *
 * Files modified:
 * - snippets/product-listing.liquid (added data attributes and changed swatches from <a> to <button>)
 * - layout/theme.liquid (added script include)
 * - assets/stylesheet.css (added active swatch styles)
 */

(function() {
  'use strict';

  const ProductCardSwatches = {

    selectors: {
      swatch: '.js-color-swatch',
      productCard: '[data-product-card]',
      swatchesWrapper: '[data-product-swatches]',
      productImage: '.reveal img:first-child',
      revealContainer: '.reveal'
    },

    init: function() {
      this.bindEvents();
    },

    bindEvents: function() {
      // Use event delegation for better performance and to handle dynamically added content
      document.addEventListener('click', this.handleSwatchClick.bind(this));
    },

    handleSwatchClick: function(event) {
      const swatch = event.target.closest(this.selectors.swatch);
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();

      const productId = swatch.dataset.productId;
      const variantImage = swatch.dataset.variantImage;

      // Update active state
      this.setActiveSwatch(swatch, productId);

      // Update image if variant has an image
      if (variantImage) {
        this.updateProductImage(productId, variantImage);
      }
    },

    setActiveSwatch: function(activeSwatch, productId) {
      // Find the swatches wrapper for this product
      const swatchesWrapper = document.querySelector(`${this.selectors.swatchesWrapper}[data-product-swatches="${productId}"]`);

      if (swatchesWrapper) {
        // Remove active class from all swatches in this product card
        const allSwatches = swatchesWrapper.querySelectorAll(this.selectors.swatch);
        allSwatches.forEach(function(swatch) {
          swatch.classList.remove('is-active');
        });
      }

      // Add active class to clicked swatch
      activeSwatch.classList.add('is-active');
    },

    updateProductImage: function(productId, imageUrl) {
      // Find the product card by data attribute
      const productCard = document.querySelector(`${this.selectors.productCard}[data-product-card="${productId}"]`);
      if (!productCard) return;

      // Find the reveal container and main image
      const revealContainer = productCard.querySelector(this.selectors.revealContainer);
      if (!revealContainer) return;

      const mainImage = revealContainer.querySelector('img');
      if (!mainImage) return;

      // Update image src and srcset
      mainImage.src = imageUrl;
      if (mainImage.srcset) {
        mainImage.srcset = imageUrl;
      }
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      ProductCardSwatches.init();
    });
  } else {
    ProductCardSwatches.init();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    ProductCardSwatches.init();
  });

  // Expose to global scope
  window.ProductCardSwatches = ProductCardSwatches;

})();
